module.exports = __webpack_public_path__ + "img/7.28a109b.svg";